import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Link = styled.a.withConfig({
  displayName: "NavOption__Link",
  componentId: "sc-1fvfjcn-0"
})([""]);
var Option = styled.div.withConfig({
  displayName: "NavOption__Option",
  componentId: "sc-1fvfjcn-1"
})(["position:relative;flex-shrink:0;padding:18px 0;margin:0 15px;color:", ";&:hover{color:", ";}&:first-child{margin:", ";}", ";"], function (_ref) {
  var theme = _ref.theme,
    selected = _ref.selected;
  return selected ? theme.mainColor : theme.colors.font;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mainColor;
}, function (_ref3) {
  var back = _ref3.back;
  return back ? '0 15px' : '0 15px 0 0 ';
}, maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
export var NavOptionLink = Option.withComponent(Link);
export var NavOption = styled(Option).withConfig({
  displayName: "NavOption",
  componentId: "sc-1fvfjcn-2"
})(["padding-right:21px;cursor:default;svg{position:absolute;top:24px;right:0;}ul{position:absolute;z-index:29;top:54px;left:-5px;visibility:hidden;opacity:0;padding:6px 0;border-radius:", ";box-shadow:", ";background:#fff;line-height:30px;white-space:nowrap;transform:translateY(-6px);transition:opacity 0.15s 0s ease,transform 0.15s 0s cubic-bezier(0.49,0.42,0.52,0.98),visibility 0s 0.15s ease;}&:hover{ul{visibility:visible;opacity:1;transform:translateY(0);transition:opacity 0.15s 0s ease,transform 0.15s 0s cubic-bezier(0.49,0.42,0.52,0.98),visibility 0s 0s ease;}}", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.boxShadow;
}, maxMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    span {\n      display: none;\n    }\n  "]))));